export class GetElementUtils {
  static byId(element: string, fallback: HTMLElement) {
    const elementById = document?.getElementById(element);
    if (elementById) {
      return elementById;
    } else {
      return fallback;
    }
  }
}
